import { useState } from "react";
import SupportsAPI from "../../../../api/SupportsAPI";

const useUpdateTicketStatus = () => {
	const [loading, setLoading] = useState(false);

	const updateTicket = async (data) => {
		setLoading(true);

		try {
			const result = await SupportsAPI.updateTicketStatus(data);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update ticket status:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateTicket,
		loading,
	};
};

export default useUpdateTicketStatus;
